<template>
    <section id="clients" class="section-padding ">
        <div class="container-fluid">
            <div class="section-header text-center">
                <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">{{$t('menus.Clients')}}</h2>
                <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
            </div>
            <div class="row img ">
                <img class="img-fluid wow fadeInDown" data-wow-delay="0.4s" src="../assets/img/v2/services-dttcs-01.svg" alt="" >
            </div>
            <div class="row">

                <!-- Clients item -->
                <div class="col-md-6  col-xs-12">
                    <div class="client-item wow fadeInLeft" data-wow-delay="0.3s">
                        <div class="icon wow fadeInLeft" data-wow-delay="0.3s">
                            <img class="img-fluid" src="../assets/img/clients/umbrella-client.svg" alt="">
                        </div>
                        <div class="services-content">
                            <h3>{{$t('clients.statement.title')}}</h3>
                            <p v-for="index in 3" :key="index" v-html="$t('clients.statement.txt' + index)" ></p>

                            <button style="margin: auto" v-b-modal.modal-statement class="btn btn-border mt-3 line-out">{{$t('readMore')}}</button>
                        </div>
                    </div>
                </div>
                <!-- Services item -->
                <div class="col-md-6  col-xs-12">
                    <div class="client-item wow fadeInRight" data-wow-delay="0.6s">
                        <div class="icon">
                            <img class="img-fluid" src="../assets/img/clients/legal.svg" alt="">
                        </div>
                        <div class="services-content">
                            <h3> {{$t('clients.privacy_practices.title')}}</h3>
                            <p v-for="index in 2" :key="'phitxt'+index" v-html="$t('clients.privacy_practices.phi.txt' + index)" ></p>
                            <button style="margin: auto" v-b-modal.modal-notice-privacy class="btn btn-border mt-3 line-out">{{$t('readMore')}}</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Clients"
    }
</script>

<style scoped>

</style>
